import * as Select from "@radix-ui/react-select";
import { FormikProps } from "formik";
import ValidationError from "./ValidationError";
import CheckIcon from "../icons/AikaIcons/CheckIcon";

interface FormSelectProps<T> {
  formik: FormikProps<T>;
  name: string;
  options: {
    value: string;
    label: string;
  }[];
  placeholder?: string;
  className?: string;
  defaultValue?: string;
}

export function FormSelect<T>({
  formik,
  name,
  options,
  placeholder = "Vælg ...",
  className,
  defaultValue,
}: FormSelectProps<T>) {
  const { errors, touched, setFieldValue, setFieldTouched } = formik;
  const field = formik.getFieldProps(name);

  return (
    <div className="col-12">
      <Select.Root
        defaultValue={defaultValue}
        onValueChange={(value) => setFieldValue(name, value)}
        onOpenChange={() => setFieldTouched(name, true)}
      >
        <Select.Trigger
          className={`c-select-trigger ${
            errors[name] && touched[name] ? "is-invalid" : ""
          } ${className || ""}`}
          title={field.value}
        >
          <Select.Value placeholder={placeholder} />
        </Select.Trigger>
        <Select.Portal>
          <Select.Content className="c-select-content">
            <Select.Viewport className="c-select-viewport">
              {options.map(({ label, value }, index) => (
                <Select.Item
                  className="c-select-option"
                  key={index}
                  value={value}
                >
                  <Select.ItemIndicator className="c-select-indicator">
                    <CheckIcon />
                  </Select.ItemIndicator>
                  <Select.ItemText>{label}</Select.ItemText>
                </Select.Item>
              ))}
            </Select.Viewport>
          </Select.Content>
        </Select.Portal>
      </Select.Root>
      <ValidationError error={errors[name]} show={touched[name]} />
    </div>
  );
}
